module.exports = __webpack_public_path__ + "static/media/tm.64aa750d.svg";